var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-ver": _vm.$root.content.version } }, [
    _c("div", { staticClass: "wrapper__header" }, [
      _c("div", { staticClass: "wrapper__headerImage" }, [
        _c("div", {
          staticClass: "headerImage__shadow",
          style: {
            backgroundImage:
              "url(" +
              _vm.allImages[_vm.$root.content.header.image.src]
                .ImgthumbBlurLarge +
              ")"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "headerImage__background" }, [
          _c("img", {
            staticClass: "headerImage",
            attrs: {
              src: _vm.allImages[_vm.$root.content.header.image.src].Img800,
              alt: _vm.$root.content.header.image.alt
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "headerContent" }, [
          _c("div", { staticClass: "headerContent__text" }, [
            _c(
              "div",
              [
                _c(
                  "div",
                  {
                    directives: [{ name: "scaletext", rawName: "v-scaletext" }]
                  },
                  [
                    _c("h3", { staticClass: "headerContent__text--title" }, [
                      _vm._v(_vm._s(_vm.$root.content.header.title))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.$root.content.header.intro, function(par, i) {
                  return _c(
                    "p",
                    {
                      directives: [
                        { name: "balancetext", rawName: "v-balancetext" }
                      ],
                      key: "intro-par-" + i,
                      staticClass: "headerContent__text--intro"
                    },
                    [_vm._v(_vm._s(par))]
                  )
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "headerContent__display" }, [
            _c("img", {
              attrs: {
                src: _vm.$root.content.header.book,
                alt: "Lawyer X book cover"
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wrapper__parts" },
            _vm._l(_vm.$root.content.parts, function(part, i) {
              return _c(
                "a",
                {
                  key: "part-" + i,
                  class: {
                    wrapper__link: true,
                    "wrapper__link--hover": _vm.hoveredLink === part.type
                  },
                  style: _vm.style__link,
                  attrs: { href: part.link },
                  on: {
                    mouseover: function($event) {
                      _vm.mouseoverLink(part.type)
                    },
                    mouseout: _vm.mouseoutLink,
                    click: function($event) {
                      _vm.trackClick(part.title)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "glow" }),
                  _vm._v(" "),
                  _c("p", { staticClass: "link__text link__text--title" }, [
                    _c("b", [_vm._v(_vm._s(part.title))])
                  ]),
                  _vm._v(" "),
                  part.subtitle
                    ? _c(
                        "p",
                        { staticClass: "link__text link__text--subtitle" },
                        [_c("i", [_vm._v(_vm._s(part.subtitle))])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "icon__wrapper" }, [
                    _c(part.icon, { tag: "div", attrs: { fill: "#efefef" } })
                  ])
                ]
              )
            })
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f7b704e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f7b704e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/link-block.vue
// module id = null
// module chunks = 